import type {
  ApiImage,
  GradientInfoHeaderContentBlock,
  WaveLinkHeaderContentBlock,
} from '@library/api-menu-experience'
import type {
  CollectionMerchandisingHeaderImage,
  GradientInfoHeaderMerchandising,
  WaveLinkHeaderMerchandising,
} from '@library/menu-service/internal/types'

const toApiImage = (crops: CollectionMerchandisingHeaderImage[]): ApiImage => {
  const altText = crops.find((crop) => crop.altText)?.altText

  return {
    crops: crops.map(({ altText: _altText, ...crop }) => crop),
    altText,
  }
}

export const toWaveLinkHeaderContentBlock = (
  merchandising: WaveLinkHeaderMerchandising,
): WaveLinkHeaderContentBlock => ({
  type: 'wave-link-header',
  title: merchandising.title,
  description: merchandising.description,
  headerImage: toApiImage(merchandising.headerImage),
  categorySlug: merchandising.collectionSlug,
  categoryId: merchandising.collectionId,
  color: merchandising.color,
  backgroundColor: merchandising.backgroundColor,
})

export const toGradientInfoHeaderContentBlock = (
  merchandising: GradientInfoHeaderMerchandising,
): GradientInfoHeaderContentBlock => ({
  type: 'gradient-info-header',
  title: merchandising.title,
  description: merchandising.description,
  headerImage: toApiImage(merchandising.headerImage),
  color: merchandising.color,
  gradientColor: merchandising.gradientColor,
  image: toApiImage(merchandising.image),
  imageLocation: merchandising.imageLocation,
})
